import { inject, NewInstance } from 'aurelia-framework';
import { StandardService } from 'pages/standard-setup/standards/service';
import { EventAggregator } from 'aurelia-event-aggregator';
import { DialogController } from 'aurelia-dialog';
import { ValidationRules, ValidationController, validateTrigger } from 'aurelia-validation';
import { BootstrapFormRenderer } from 'resources/validation-renderer';
import toastr from 'toastr';

@inject(DialogController, NewInstance.of(ValidationController), StandardService, EventAggregator)
export class StandardEditor {
    constructor(controller, validationController, standardService, ea) {
        this.controller = controller;
        this.standardService = standardService;
        this.ea = ea;
        this.status = {};

        this.validationController = validationController;
        this.validationController.validateTrigger = validateTrigger.manual;
        this.validationController.addRenderer(new BootstrapFormRenderer());
        this.rules = ValidationRules
            .ensure('number').required()
            .rules;
    }

    async activate(model) {
        if (model?.id != null) {
            this.standard = await this.standardService.getById(model.id);
        }
    }

 

    async save() {
        if (this.isRequesting) return;
        this.isRequesting = true;
        const validationResult = await this.validationController.validate();
        if (validationResult.valid) {
            try {
                if (this.standard.id) {
                    await this.standardService.update(this.standard);
                    toastr.success('Standard was updated!');
                } else {
                    await this.standardService.create(this.standard);
                    toastr.success('New standard was created!');
                }
                this.ea.publish('standards:updated', this.standard);
                this.controller.ok(this.standard);
            } catch {
                this.isRequesting = false;
            }
        }
        this.isRequesting = false;
    }
}